import type { MapOptions } from "mapbox-gl";
import i18n from "@/i18n";

export function getMapboxPublicToken(): string | undefined {
  const token = import.meta.env.VITE_MAPBOX_PUBLIC_TOKEN?.trim();
  return token || undefined;
}

export function getMapboxStyleUrl(): string {
  const style = import.meta.env.VITE_MAPBOX_STYLE_URL?.trim();
  return style || "mapbox://styles/mapbox/streets-v12";
}

/**
 * Inline maps sit in a scrolling page and must not swallow the wheel: plain
 * scroll moves the page, Ctrl/⌘ + scroll (or two fingers on touch) moves the
 * map. An expanded (modal) map owns the viewport, so its gestures stay free.
 */
export function getMapboxGestureOptions(
  cooperative: boolean,
): Pick<MapOptions, "cooperativeGestures" | "locale"> {
  return {
    cooperativeGestures: cooperative,
    locale: {
      "ScrollZoomBlocker.CtrlMessage": i18n.t("map.zoomHintCtrl", { ns: "common" }),
      "ScrollZoomBlocker.CmdMessage": i18n.t("map.zoomHintCmd", { ns: "common" }),
      "TouchPanBlocker.Message": i18n.t("map.panHintTouch", { ns: "common" }),
    },
  };
}
